import { SUMMARY_STATUS, SET_SUMMARY_STATUS, SET_SUMMARY_RESPONSE, SET_SUMMARY_ERROR, RESET_SUMMARY_STATE } from './constants';

export const initialState = {
  summaryStatus: SUMMARY_STATUS.NOT_REQUESTED,
  summaryResponse: null,
  summaryError: null,
};

// eslint-disable-next-line default-param-last
export default function summaryReducer(state = initialState, action) {
  switch (action.type) {
    case SET_SUMMARY_STATUS: {
      const { summaryStatus } = action.payload;
      return {
        ...state,
        summaryStatus,
      };
    }
    case SET_SUMMARY_RESPONSE: {
      const { summaryResponse } = action.payload;
      return {
        ...state,
        summaryResponse,
      };
    }
    case SET_SUMMARY_ERROR: {
      const { summaryError } = action.payload;
      return {
        ...state,
        summaryError,
      };
    }
    case RESET_SUMMARY_STATE: {
      return { ...initialState };
    }
    default:
      return state;
  }
}
